import { IForceSyncOrderStatusRule } from '../force-sync-order-status-rule.interface';

export class CanceledForceSyncRule implements IForceSyncOrderStatusRule {
  showForceSync(): boolean {
    return false;
  }
}
